import NotificationTemplatesApi from 'api/admins/notification-templates-api'
import TitlePage from 'components/atoms/title-page'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Card } from 'reactstrap'
import { useHistory } from 'react-router'
import NotificationTemplateTable from 'domains/announcements/components/notification-template-table/notification-template-table'
import { useModal } from 'providers/modal-provider'
import confirmationModal from 'components/organisms/confirmation-modal'
import { ALERT_TYPES } from 'constants/alert-constants'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const DEFAULT_FILTERS = {
  page           : 1,
  perPage        : 10,
  name           : '',
  text           : '',
  channel        : '',
  provider       : '',
  scheduled_date : '2000-01-01 00:00:00 +0700',
  sort_by        : 'created_at',
  sort_order     : 'desc'
}

const NotificationTemplateScheduledListPage = ({ pageUtils }) => {
  // const [ isLoading, setIsLoading ]   = useState(false)
  // const [ templates, setTemplates ]   = useState([])
  // const [ pagination, setPagination ] = useState({})

  // const { showModal, hideModal } = useModal()

  // const history  = useHistory()
  // const filters  = Object.fromEntries(new URLSearchParams(location.search))
  // const pathName = Object.fromEntries(new URLSearchParams(location)).pathname

  // const handleFecthTemplates = async () => {
  //   setIsLoading(true)
  //   let params          = DEFAULT_FILTERS
  //   const isEmptyParams = Object.keys(filters).length === 0

  //   if (!isEmptyParams) {
  //     params = filters
  //   }

  //   await NotificationTemplatesApi.get(params)
  //     .then((response) => {
  //       setTemplates(response.data.templates)
  //       setPagination(response.data.meta)
  //     })
  //     .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  //     .finally(() => setIsLoading(false))
  // }

  // useEffect(() => {
  //   handleFecthTemplates()
  // }, [ location.search ])

  // const executeCancelSchedule =  (template) => {
  //   NotificationTemplatesApi.cancel_scheduled({ scheduleRequest: template })
  //     .then(() => {
  //       pageUtils.setAlertMsg(`Scheduled Template ${template.name} has been cancelled.`, ALERT_TYPES.SUCCESS)
  //       handleFecthTemplates()
  //     })
  //     .catch((error) => {
  //       pageUtils.setApiErrorMsg(error.response.data)
  //     })
  //     .finally(() => hideModal())
  // }

  // const handleClickCancelSchedule = (template) => {
  //   const title = 'Cancel Scheduled Template Blast'
  //   const body  = `Do you want cancel ${template.name} blast to ${template.receiver_size} receivers ?`
  //   showModal(confirmationModal, {
  //     title              : title,
  //     children           : body,
  //     handleConfirmation : async () => executeCancelSchedule(template)
  //   })
  // }

  // // TODO: waiting for api reschedule template
  // // const handleClickReschedule = async (template, newScheduledDate) => {
  // //   setIsLoading(true)

  // //   const rescheduledDate = {
  // //     id             : template.id,
  // //     scheduled_date : newScheduledDate
  // //   }

  // //   await NotificationTemplatesApi.reschedule(rescheduledDate)
  // //     .then(() => {
  // //       handleFecthTemplates()
  // //     })
  // //     .catch((error) => {
  // //       pageUtils.setApiErrorMsg(error.response.data)
  // //     })
  // //     .finally(() => setIsLoading(false))
  // // }

  // const handlePageChange = (page) => {
  //   const params = filters
  //   //replace page value
  //   params[ 'page' ] = page
  //   history.push({
  //     pathname : pathName,
  //     search   : new URLSearchParams(params).toString()
  //   })
  // }

  // return (
  //   <>
  //     <TitlePage mainTitle={ 'Notification' } subTitle={ 'Template Scheduled List' } />
  //     <Card>
  //       <NotificationTemplateTable
  //         templates={ templates }
  //         onClickCancelScehdule={ handleClickCancelSchedule }
  //         // onClickReschedule={ handleClickReschedule } TODO: waiting for api reschedule template
  //         onPageChange={ handlePageChange }
  //         isLoading={ isLoading }
  //         pagination={ pagination }
  //       />
  //     </Card>
  //   </>
  //)
}
NotificationTemplateScheduledListPage.propTypes = propTypes
export default NotificationTemplateScheduledListPage
